import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '~/environments/environment';
import {PromoPartner} from '@models/promo';

// Résolution d'un code affilié (endpoint public GET /app/affiliate/{code}).
// 200 -> bloc affilié (PromoPartner), 404 -> code invalide / affilié inactif.
@Injectable({
    providedIn: 'root'
})
export class AffiliateService {

    constructor(private http: HttpClient) {
    }

    resolve(code: string): Observable<PromoPartner> {
        return this.http.get<PromoPartner>(environment.apiUrl + 'app/affiliate/' + code);
    }
}
